import {useState} from 'react';
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Content from "./Components/Content";
import {FinishResultContent} from "./Swagger";
import {Box, Typography, Button, CircularProgress} from "@mui/material";
import {ApiClient} from "./Api";

function HandInFailed() {
    const {t, i18n} = useTranslation();
    const location = useLocation();
    const state = location.state as FinishResultContent;
    const { id } = useParams();
    const navigate = useNavigate();
    const [finishing, setFinishing] = useState(false);
    const [finishResult, setFinishResult] = useState<FinishResultContent>();
    
    async function finishHandIn() {
        setFinishing(true);

        try {
            const handinDetailResponse = await ApiClient.instance.api.editorHandinDetail(id!);

            const response = await ApiClient.instance.api.editorHandinFinishCreate(id || "", { danish: i18n.language === "da" });
            if (response.data.success) {
                if (handinDetailResponse.data.receptRedirectUri?.indexOf("://")) {
                    window.location.href = handinDetailResponse.data.receptRedirectUri;
                } else {
                    navigate(handinDetailResponse.data.receptRedirectUri!, {
                        state: response.data.content
                    });
                }
            }

            setFinishResult(response.data.content);
            setFinishing(false);
        } catch {
            setFinishing(false);
        }

    }
    
    return (
        <Box sx={{p: 3}}>
            <Typography>Det lykkedes ikke at aflevere, prøv igen ved at trykke på knappen</Typography>
            {state && 
                <Box><Content contentType={state.type || ""} content={state.content || ""}/></Box>
            }
            {finishing &&
                <Box sx={{p: 1}}><CircularProgress/></Box>
            }
            {!finishing && 
                <Button onClick={finishHandIn}>{t("finishHandin")}</Button>
            }
        </Box>
    )
}

export default HandInFailed;